import React from 'react';

export const Separator: React.FC = () => {
  return <div className="h-px w-full bg-gray-300" />;
};
